import { ControlsBaseComponent } from './../shared/components/controls-base.component';
import { Component } from '@angular/core';
import { ControlContainer, FormGroupDirective } from '@angular/forms';
import { JsonDynamicComponentService } from '../json-dynamic-component.service';
import { CommonUtilsService } from '../shared/common-utils.service';

@Component({
  selector: 'ra-input-control',
  templateUrl: './input-control.component.html',
  styleUrls: ['./input-control.component.scss'],
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective,
    },
  ],
  standalone: false,
})
export class InputControlComponent extends ControlsBaseComponent {
  constructor(
    protected jsonDynamicComponentService: JsonDynamicComponentService,
    protected commonUtils: CommonUtilsService,
  ) {
    super(jsonDynamicComponentService, commonUtils);
  }
}
